import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, RadioLabel } from '@weezevent/nacre';
import css from '../zones.module.css';

function TypeSelector({ value, form, onChange = () => {} }) {
    const { t } = useTranslation();

    const active = React.useMemo(() => {
        return form.type === value;
    }, [form, value]);

    const isSeated = React.useMemo(() => {
        return value === 'seated';
    }, [value]);

    const title = React.useMemo(() => {
        if (value === 'seated') {
            return t('ticket.common.seating.numberedSeating');
        }
        if (value === 'general_admission') {
            return t('partners.common.seating.freeSeating');
        }
    }, [value]);

    return (
        <RadioLabel
            label={
                <div className={css['radio-type-selector']}>
                    {title}
                    <Icon className={css['seated-zone-icon']} name={isSeated ? 'seat' : 'male'} size="regular" color={active && 'ticket'} />
                </div>
            }
            value={value}
            checked={active}
            inline
            bordered
            disabled={form.zone?.uuid}
            onChange={({ target: { value } }) => {
                onChange(value);
            }}
        />
    );
}

export default TypeSelector;
